<template>
  <div class="info_page page">
    <Stage :navNum="4" />
    <span class="title">账号转移信息核对</span>
    <div class="info_box">
      <div class="user_info">
        <i class="user_icon"></i>
        <span>转移账号：{{ $parent.user }}</span>
      </div>
      <div class="out_box">
        <div class="out_icon">转出</div>
        <div class="out_info">
          <span>{{ $parent.system == 1 ? '苹果' : '安卓' }}</span>
          <span>{{
            `账号在该平台下共${$parent.$refs.login.roleList.length}名角色`
          }}</span>
        </div>
      </div>
      <i class="info_line"></i>
      <div class="in_box">
        <div class="in_icon">转入</div>
        <div class="in_info">
          <span>{{ $parent.system == 1 ? '安卓' : '苹果' }}</span>
          <span>{{ `账号在该平台下共${transinNum}名角色` }}</span>
        </div>
      </div>
      <i class="info_line2"></i>
      <span class="transform_tip">转移说明： </span>
      <span class="transform_tip">1.转移前后，角色数据及所在服务器不变。</span>
      <span class="transform_tip"
        >2.若账号下有多名角色，转移后所有角色的数据会一并转移！</span
      >
    </div>
    <span class="tip_text" v-if="transinNum != 0"
      >检测到您的账号在转入平台有角色数据，确认转移后，将覆盖目标平台的角色数据！</span
    >
    <div class="btn_box">
      <div class="pre_btn" @click="$parent.currentPage--">上一步</div>
      <div class="next_btn" @click="goNext">下一步</div>
    </div>
  </div>
</template>

<script>
import { getRoleList } from '../api/index';
import Stage from './childcomponents/Stage.vue';
export default {
  components: {
    Stage
  },
  data() {
    return {
      transinNum: 0 //转入平台的角色数
    };
  },
  computed: {},
  watch: {
    '$parent.loginStatus': function () {
      if (this.$parent.loginStatus) {
        let t = new Date().getTime();
        getRoleList({
          appkey: 1486458782785,
          sign: this.$md5(
            t +
              this.$md5(
                1486458782785 +
                  this.$parent.userid +
                  (this.$parent.system == 1 ? '2' : '1')
              ) +
              'UIwf 8-08e30P)*_)@$e;l23r'
          ),
          userid: this.$parent.userid,
          type: this.$parent.system == 1 ? 2 : 1,
          t: t,
          token: this.$parent.token,
          deviceid: this.$parent.deviceId,
          cert: this.$parent.cert
        }).then((res) => {
          console.log(res);
          if (res.data.data.success) {
            this.transinNum = res.data.data.list.length;
          } else {
            this.$parent.getTip(`查询账号转入信息失败--${res.data.data.code}`);
          }
        });
      }
    }
  },
  methods: {
    goNext() {
      if (this.transinNum > 0) {
        this.$parent.popShow = 'transform';
      } else {
        this.$parent.currentPage++;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.info_page {
  .title {
    width: 100%;
    font-weight: 500;
    color: #1b1919;
    font-size: 0.32rem;
    margin-top: 0.46rem;
    margin-bottom: 0.34rem;
    flex-shrink: 0;
    padding: 0 0.32rem;
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .info_box {
    flex-shrink: 0;
    width: 7.5rem;
    height: 7.61rem;
    background: #feffff;
    .layout-flex(@col,normal,normal);
    padding: 0 0.32rem;
    box-sizing: border-box;
    .user_info {
      margin-top: 0.36rem;
      margin-bottom: 0.4rem;
      width: 100%;
      height: 1.38rem;
      background: #ecf6ff;
      border-radius: 0.2rem;
      .layout-flex(@r,normal,@c);
      .user_icon {
        width: 0.86rem;
        height: 0.86rem;
        background: url('../assets/user_icon.png');
        background-size: 100% 100%;
        margin-right: 0.32rem;
        margin-left: 0.4rem;
      }
      span {
        color: #656565;
        font-size: 0.28rem;
      }
    }
    .out_box {
      width: 100%;
      height: 1.14rem;
      .layout-flex(@r,normal,@c);
      .out_icon {
        width: 1.14rem;
        height: 1.14rem;
        background: #e8f1fc;
        border-radius: 0.2rem;
        font-weight: 500;
        color: #3e73fe;
        font-size: 0.32rem;
        .layout-flex(@r,@c,@c);
        margin-right: 0.23rem;
      }
      .out_info {
        .layout-flex(@col,@c,@s);
        span:nth-child(1) {
          color: #3e73fe;
          font-weight: 500;
          font-size: 0.28rem;
        }
        span:nth-child(2) {
          color: #656565;
          font-size: 0.28rem;
        }
      }
    }
    .info_line {
      width: 100%;
      height: 0.02rem;
      background: #dddede;
      opacity: 0.55;
      margin: 0.32rem 0;
    }
    .in_box {
      width: 100%;
      height: 1.14rem;
      .layout-flex(@r,normal,@c);
      .in_icon {
        width: 1.14rem;
        height: 1.14rem;
        background: #e6f9e5;
        border-radius: 0.2rem;
        font-weight: 500;
        color: #67b66b;
        font-size: 0.32rem;
        .layout-flex(@r,@c,@c);
        margin-right: 0.23rem;
      }
      .in_info {
        .layout-flex(@col,@c,@s);
        span:nth-child(1) {
          color: #67b66b;
          font-weight: 500;
          font-size: 0.28rem;
        }
        span:nth-child(2) {
          color: #656565;
          font-size: 0.28rem;
        }
      }
    }
    .info_line2 {
      width: 100%;
      height: 0.02rem;
      background: #dddede;
      opacity: 0.55;
      margin-top: 0.34rem;
      margin-bottom: 0.56rem;
    }
    .transform_tip {
      color: #656565;
      font-size: 0.24rem;
      line-height: 0.4rem;
      margin-left: 0.2rem;
    }
  }
  .tip_text {
    margin: 0 0.52rem;
    margin-top: 0.34rem;
    color: #fb6c3e;
    line-height: 0.4rem;
    font-size: 0.24rem;
    flex-shrink: 0;
  }
  .btn_box {
    margin-top: 0.5rem;
  }
}
</style>